export default "__VITE_ASSET__PmNGROQr__"